import {IconButton} from '@primer/react'
import type React from 'react'
import {useRef, useState} from 'react'

import MCPIcon from './icons/MCPIcon'
import {McpToolsManager} from './McpToolsManager'

export const McpToolMenu: React.FC = () => {
  const [toolsOpen, setToolsOpen] = useState(false)
  const toolsButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <IconButton
        ref={toolsButtonRef}
        icon={MCPIcon}
        variant="invisible"
        aria-label="MCP tools"
        onClick={() => setToolsOpen(!toolsOpen)}
      />
      <McpToolsManager anchorRef={toolsButtonRef} open={toolsOpen} onOpenChange={setToolsOpen} />
    </>
  )
}

try{ McpToolMenu.displayName ||= 'McpToolMenu' } catch {}